import { create } from 'zustand';

interface PricingConfigState {
  activeTab: 'machines' | 'processes' | 'wastage' | 'box-presets';
  setActiveTab: (tab: 'machines' | 'processes' | 'wastage' | 'box-presets') => void;
  // Modal states for Machine
  isMachineModalOpen: boolean;
  selectedMachineId: string | null;
  openMachineModal: (id?: string) => void;
  closeMachineModal: () => void;
  // Modal states for Process
  isProcessModalOpen: boolean;
  selectedProcessId: string | null;
  openProcessModal: (id?: string) => void;
  closeProcessModal: () => void;
  // Modal states for Wastage
  isWastageModalOpen: boolean;
  selectedWastageId: string | null;
  openWastageModal: (id?: string) => void;
  closeWastageModal: () => void;
}

export const usePricingConfigStore = create<PricingConfigState>((set) => ({
  activeTab: 'machines',
  setActiveTab: (tab) => set({ activeTab: tab }),

  isMachineModalOpen: false,
  selectedMachineId: null,
  openMachineModal: (id) => set({ isMachineModalOpen: true, selectedMachineId: id || null }),
  closeMachineModal: () => set({ isMachineModalOpen: false, selectedMachineId: null }),

  isProcessModalOpen: false,
  selectedProcessId: null,
  openProcessModal: (id) => set({ isProcessModalOpen: true, selectedProcessId: id || null }),
  closeProcessModal: () => set({ isProcessModalOpen: false, selectedProcessId: null }),

  isWastageModalOpen: false,
  selectedWastageId: null,
  openWastageModal: (id) => set({ isWastageModalOpen: true, selectedWastageId: id || null }),
  closeWastageModal: () => set({ isWastageModalOpen: false, selectedWastageId: null }),
}));
